(function () {

    'use strict';

    var ngModule = angular.module('breakmarkApp');

	ngModule.directive('storeDetailsForm', [ '$Teams', '$firebaseArray', '$timeout', function ($Teams, $firebaseArray, $timeout) {

		return {
			scope: {
				store: '='
			},
			templateUrl:'directives/storeDetailsForm/detailsForm.html',


			controller: function($scope) {

                $scope.storeUrl = location.protocol + '//' + location.host + '/storefront/' + $scope.store.$id;
                $scope.orderUrl = location.protocol + '//' + location.host + '/teamorder/' + $scope.store.$id;

                $scope.datetimeOptions = {
                    widgetPositioning:{
                        vertical:'bottom'
                    },
                    useCurrent: false,
                    defaultDate: moment(),
                    // format: 'x',
                    format: 'MM/DD/YYYY h:mm A',
                    showClose:true,
                    showClear: true,
                    toolbarPlacement: 'top'
                };

                // console.log('parent',$scope.$parent);

				// $scope.teamList = $Teams.all();

			}
		};

	}]);

})();
